var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.324 19.709a1 1 0 0 1-1.579-1.228zM20.767 18.481a1.001 1.001 0 0 1-1.58 1.228zM21.5 4a1 1 0 0 1 0 2h-7.862a3 3 0 0 0-2.758 1.818L5.919 19.394a1.001 1.001 0 0 1-1.793.091l-2.5-4.5a1 1 0 0 1 1.694-1.057l.054.087 1.51 2.717L9.042 7.03A5 5 0 0 1 13.638 4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.254 8.836a1.001 1.001 0 0 1 1.57 1.222l-.058.084-3.243 4.169 3.244 4.17-.79.614-.79.614-2.931-3.77-2.932 3.77-.789-.614-.79-.614 3.243-4.17-3.242-4.17-.058-.083a1 1 0 0 1 1.57-1.222l.066.077 2.932 3.769 2.932-3.769z"
  })));
};
export default Svg24;